import { useBlocksConfig } from "@pathwright/blocks-engine"
import { Content } from "@pathwright/ui/src/components/content/Content"
import get from "lodash/get"
import { Motion, spring } from "react-motion"
import Feedback from "../../block/BlockFeedback/view"
import BlockSubmit from "../../block/BlockSubmit"
import Matching from "./Matching/view"
import MultipleChoice from "./MultipleChoice/view"
import Paragraph from "./Paragraph/view"
import QuestionHeader from "./QuestionHeader"
import { QuestionContainer } from "./ui"

const QuestionView = (props) => {
  const { blockStyles, data, layout, onChange } = props

  const { hideAssessmentFeedback } = useBlocksConfig()

  const isSubmitted = get(data, "answer.hasSubmitted", false)

  const renderQuestion = () => {
    switch (layout) {
      case "multipleChoice":
        return <MultipleChoice {...props} />
      case "checkBoxes":
        return <MultipleChoice {...props} />
      case "matching":
        return <Matching {...props} />
      default:
        return <Paragraph {...props} />
    }
  }

  const renderFeedback = () => {
    return isSubmitted ? (
      <Motion defaultStyle={{ v: 0 }} style={{ v: spring(1) }}>
        {({ v }) => (
          <Feedback
            feedbackList={data.feedback}
            style={{
              position: "relative",
              opacity: v,
              transform: `translateY(${(1 - v) * -20}px)`
            }}
          />
        )}
      </Motion>
    ) : null
  }

  const handleSubmit = () => {
    const submission = {
      answer: {
        ...(data.answer || {}),
        hasSubmitted: true,
        answeredDate: new Date().getTime()
      }
    }
    onChange({ ...submission }, true)
  }

  const handleUnsubmit = () => {
    const unsubmission = {
      answer: {
        ...(data.answer || {}),
        hasSubmitted: false,
        answeredDate: null
      }
    }
    onChange({ ...unsubmission }, true)
  }

  return (
    <Content.Container
      style={{ maxHeight: "100%" }} // prevent preview from looking wonky
      flexForPrint={true}
    >
      <QuestionContainer blockStyles={blockStyles}>
        <div style={{ width: "100%", marginBottom: "1rem" }}>
          <QuestionHeader {...props} />
          {renderQuestion()}
        </div>
        {!hideAssessmentFeedback && renderFeedback()}
        <footer>
          <BlockSubmit
            onSubmit={handleSubmit}
            onUnsubmit={handleUnsubmit}
            isSubmitted={isSubmitted}
            answeredDate={get(data, "answer.answeredDate", null)}
          />
        </footer>
      </QuestionContainer>
    </Content.Container>
  )
}

export default QuestionView
